import { DependencyList, RefObject, useEffect } from 'react'

// containerRef and deps are both optional so every existing call site
// (useScrollToTop() with no arguments — a plain "scroll the window on
// mount") keeps behaving exactly as before: no ref scrolls window, and an
// empty deps array fires once on mount.
//
// containerRef exists because not every scrollable surface IS the window —
// classroom-v2's player, for instance, keeps the window fixed and scrolls an
// inner Box instead (see course-player.tsx), so scrolling window there would
// be a no-op.
//
// deps exists because a route that never remounts — again, the player, which
// swaps steps and phases without navigating anywhere — has no "on mount" to
// hook into. Passing the values that identify the current view (step index,
// phase kind) re-fires this on every view change instead of only once.
export function useScrollToTop(
  containerRef?: RefObject<HTMLElement | null>,
  deps: DependencyList = [],
) {
  useEffect(() => {
    if (containerRef?.current) {
      containerRef.current.scrollTo(0, 0)
      return
    }
    window.scroll(0, 0)
  }, deps)
}
